import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import Script from "./assetsCon/Script";
import Css from "./assetsCon/Css";

const root = ReactDOM.createRoot(document.getElementById("root"));
const originalFetch = fetch;
window.fetch = async (url, options = {}) => {
    const defaultHeaders = {
       "version":2
    };
    options.headers = {
        ...defaultHeaders,
        ...options.headers, // Merge with any headers passed in the options
    };
    try {
        const response = await originalFetch(url, options);
        return response;
    } catch (error) {
        console.error('Fetch error:', error);
        throw error;
    }
};
root.render(
  <>
    <Css />
    <Script />
    <React.StrictMode>
      <App />
    </React.StrictMode>
  </>
);

reportWebVitals();
